export default "__VITE_ASSET__1148fc94__"